<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back" class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto"
        type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Modal Header</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>

<h2 class="u-pa-20 u-ma-0">
  Single Modal
</h2>

<maced-modal-header [title]="title" [subtitle]="subtitle" id="Modal Header 1" [cancelUrl]="cancelUrl" [defaultHeading]="defaultHeading"
  closeButtonAriaLabel="Close" backButtonAriaLabel="Back" [hasTooltip]="true" [tootipModelId]="'modalHeader1'">
</maced-modal-header>

<br>

<maced-modal-header [title]="titleSpanish" [subtitle]="subtitleSpanish" id="Encabezado modal 1" [cancelUrl]="cancelUrl"
  closeButtonAriaLabel="Cerca" backButtonAriaLabel="atrás">
</maced-modal-header>

<br>

<maced-modal-header [title]="titleHindi" [subtitle]="subtitleHindi" id="मोडल हैडर 1" [cancelUrl]="cancelUrl"
  closeButtonAriaLabel="बंद करे" backButtonAriaLabel="पीछे">
</maced-modal-header>

<br>
<br>

<h2 class="u-pa-20 u-ma-0">
  Multi Modal
</h2>

<maced-modal-header [title]="title" [subtitle]="subtitle" id="Modal Header 2" [isMultiStepModal]="isMultiStepModal"
  [backUrl]="backUrl" [cancelUrl]="cancelUrl" closeButtonAriaLabel="Close" backButtonAriaLabel="Back">
</maced-modal-header>

<br>

<maced-modal-header [title]="titleSpanish" [subtitle]="subtitleSpanish" id="Encabezado modal 2"
  [isMultiStepModal]="isMultiStepModal" [backUrl]="backUrl" [cancelUrl]="cancelUrl" closeButtonAriaLabel="Cerca"
  backButtonAriaLabel="atrás">
</maced-modal-header>

<br>

<maced-modal-header [title]="titleHindi" [subtitle]="subtitleHindi" id="मोडल हैडर 2"
  [isMultiStepModal]="isMultiStepModal" [backUrl]="backUrl" [cancelUrl]="cancelUrl" closeButtonAriaLabel="बंद करे"
  backButtonAriaLabel="पीछे">
</maced-modal-header>

<h2 class="u-pa-20 u-ma-0">
  Small Content Modal
</h2>

<maced-modal-header [title]="title" [subtitle]="subtitle" id="Modal Header 3" [isSmallContentModal]="isSmallContentModal">
  <maced-button buttonId="Action1" label="Call to action" color="primary" position="left"
  styleClass="u-button-normal"></maced-button>
</maced-modal-header>

<br>

<maced-modal-header [title]="titleSpanish" [subtitle]="subtitleSpanish" id="Encabezado modal 3" [isSmallContentModal]="isSmallContentModal">
  <maced-button buttonId="Icon Button 1" color="secondary" shape="square" icon="icon-plus" label="label">
  </maced-button>
  <maced-button buttonId="Action12" label="Call to action" color="primary"  position="left"
      styleClass="u-button-normal"></maced-button>
</maced-modal-header>

<br>

<maced-modal-header [title]="titleHindi" [subtitle]="subtitleHindi" id="मोडल हैडर 3" [isSmallContentModal]="isSmallContentModal">
  <maced-button buttonId="Icon Button 12" color="secondary" shape="square" icon="icon-plus" label="label">
  </maced-button>
  <maced-button buttonId="Action13" label="Call to action" color="primary" position="left"
      styleClass="u-button-normal"></maced-button>
</maced-modal-header>

<maced-modal-header [title]="title" [subtitle]="subtitle" id="Modal Header 3"
  [isSmallContentModal]="isSmallContentModal">
  <ng-container ngProjectAs="[toggleData]">
    <div #tooltipTargetReference class="u-display-inline-block" title="">
      <maced-toggle name="toggle5" id="toggle5" [hasToggleIcon]="true" id="toggleId"
        [ariaLabel]="toggleNgModel === toggleMode2 ? 'Switch to bookviewer' : 'Switch to reading view'"
        [(ngModel)]="toggleNgModel" [roleDescription]="role">
      </maced-toggle>
    </div>
    <maced-tooltip id="tooltip1" [hasCloseButton]="false" [hasCaret]="true" [placement]="selectedPlacement"
      [tooltipTargetReference]="tooltipTargetReference"
      [message]="toggleNgModel === toggleMode2 ? 'Switch to bookviewer' : 'Switch to reading view'">
    </maced-tooltip>
  </ng-container>
</maced-modal-header>